// extracted by mini-css-extract-plugin
export default {"label":"SelectWithoutChoice_label__0b+XN","labelTag":"SelectWithoutChoice_labelTag__iq4-C"};